import { Component, Host, h } from "@stencil/core";

@Component({
    tag: "ux-iws-media-bar",
    styleUrl: "media-bar.scss",
})
export class MediaBar {
    private baseClass = "ux-iws-media-bar";

    render() {
        return (
            <Host class={this.baseClass}>
                <div class={`${this.baseClass}__wrapper`}>
                    <div class={`${this.baseClass}__media-container`}>
                        <slot name="media"></slot>
                    </div>
                    <div class={`${this.baseClass}__content-container`}>
                        <slot name="content" />
                    </div>
                </div>
            </Host>
        );
    }
}
